var _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIreland(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#169b62",
    width: 300,
    height: 600
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    x: 300,
    width: 300,
    height: 600
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ff883e",
    x: 600,
    width: 300,
    height: 600
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIreland);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MDAiIGhlaWdodD0iNjAwIj4KPHJlY3QgZmlsbD0iIzE2OWI2MiIgd2lkdGg9IjMwMCIgaGVpZ2h0PSI2MDAiLz4KPHJlY3QgZmlsbD0iI2ZmZiIgeD0iMzAwIiB3aWR0aD0iMzAwIiBoZWlnaHQ9IjYwMCIvPgo8cmVjdCBmaWxsPSIjZmY4ODNlIiB4PSI2MDAiIHdpZHRoPSIzMDAiIGhlaWdodD0iNjAwIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };